import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'

const gridFiltersConfig: any = {
    SOBJBEREICHFILTER: { prop: null, param: 'SOBJBEREICHFILTER', url_param: false },
    SPERVONFILTER: { prop: null, param: 'SPERVONFILTER', url_param: false },
    SPERBISFILTER: { prop: null, param: 'SPERBISFILTER', url_param: false },
    NJAHRFILTER: { prop: null, param: 'NJAHRFILTER', url_param: false },
    SDATVONFILTER: { prop: null, param: 'SDATVONFILTER', url_param: false },
    SDATBISFILTER: { prop: null, param: 'SDATBISFILTER', url_param: false },
    NUNTERKONTENFILTER: { prop: null, param: 'NUNTERKONTENFILTER', url_param: false },
    NDETAILFILTER: { prop: null, param: 'NDETAILFILTER', url_param: false },
    NONLYBUFILTER: { prop: null, param: 'NONLYBUFILTER', url_param: false },
}

const initialState = {
    loadIx2060ListStatus: 'idle',
    loadIx2060ListError: undefined as any,
    loadIx2060ListLastArgs: undefined as any,
    loadEwbDataStatus: 'idle',
    loadEwbDataError: undefined as any,
    saveEwbPerDataStatus: 'idle',
    saveEwbPerDataError: undefined as any,
    updateEwbPerDataStatus: 'idle',
    updateEwbPerDataError: undefined as any,

    ix2060List: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadIx2060List = createAsyncThunk('ix2060Slice/loadIx2060List', async ({ gridFilters, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().ix2060Slice.loadIx2060ListLastArgs
    if (_.isEqual(lastArgs, { gridFilters }) && !forceReload) { return }

    let promises = []
    {
        const [url, params] = prepParams(`/api/ixweb/xsp_ewb/?SOBJBEREICH=${gridFilters.values.SOBJBEREICHFILTER}&SPERVON=${gridFilters.values.SPERVONFILTER}&SPERBIS=${gridFilters.values.SPERBISFILTER}&NJAHR=${gridFilters.values.NJAHRFILTER}&SDATVON=${gridFilters.values.SDATVONFILTER}&SDATBIS=${gridFilters.values.SDATBISFILTER}&NUNTERKONTEN=${gridFilters.values.NUNTERKONTENFILTER}&NDETAIL=${gridFilters.values.NDETAILFILTER}&NONLYBU=${gridFilters.values.NONLYBUFILTER}`, undefined, gridFilters)
        promises.push(client.get(
            url,
            {
                params,
            }
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: { gridFilters }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadIx2060ListStatus } = getState().ix2060Slice
        return loadIx2060ListStatus !== 'pending'
    }
})

export const loadEwbData = createAsyncThunk('ix2060Slice/loadEwbData', async ({ ix2060, gridFilters }: any, { rejectWithValue }: any) => {
    let promises = []
    {
        const [url, params] = prepParams(`/api/ixweb/ewbperdata/?NPERID=${ix2060.PERID}&NJAHRGANG=${gridFilters.values.NJAHRFILTER}`, undefined, gridFilters)
        promises.push(client.get(
            url,
            {
                params,
            }
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadEwbDataStatus } = getState().ix2060Slice
        return loadEwbDataStatus !== 'pending'
    }
})

export const saveEwbPerData = createAsyncThunk('ix2060Slice/saveEwbPerData', async ({ ix2060 }: any, { rejectWithValue }: any) => {
    let promises = []
    if (ix2060?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/ewbperdata/${ ix2060?.HDR_ID }/`,
            prepareData(ix2060),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/ewbperdata/`,
            prepareData(ix2060),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveEwbPerDataStatus } = getState().ix2060Slice
        return saveEwbPerDataStatus !== 'pending'
    }
})

export const updateEwbPerData = createAsyncThunk('ix2060Slice/updateEwbPerData', async ({ ix2060 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/ewbperdata/${ix2060.HDR_ID}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: ix2060.HDR_ID,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { updateEwbPerDataStatus } = getState().ix2060Slice
        return updateEwbPerDataStatus !== 'pending'
    }
})

const Ix2060Slice = createSlice({
    name: 'ix2060Slice',
    initialState,
    reducers: {
        resetloadIx2060ListError: (state) => {
            state.loadIx2060ListError = undefined
        },
        resetloadEwbData: (state) => {
            state.formItem = undefined
            state.loadEwbDataError = undefined
        },
        resetloadEwbDataError: (state) => {
            state.loadEwbDataError = undefined
        },
        resetsaveEwbPerData: (state) => {
            state.formItem = undefined
            state.saveEwbPerDataError = undefined
        },
        resetsaveEwbPerDataError: (state) => {
            state.saveEwbPerDataError = undefined
        },
        resetupdateEwbPerDataError: (state) => {
            state.updateEwbPerDataError = undefined
        },
        removeFromIx2060ListById: (state, action) => {
            state.ix2060List = state.ix2060List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromIx2060ListByIds: (state, action) => {
            state.ix2060List = state.ix2060List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.ix2060List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadIx2060ListStatus = 'preloaded'
            state.loadIx2060ListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.ix2060List = []
            state.loadIx2060ListStatus = 'idle'
            state.loadIx2060ListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadIx2060List.pending, (state) => {
            state.loadIx2060ListStatus = 'pending'
            state.loadIx2060ListError = undefined
        })
        builder.addCase(loadIx2060List.fulfilled, (state, action) => {
            state.loadIx2060ListStatus = 'idle'

            if (!action.payload) { return }

            state.loadIx2060ListLastArgs = action.payload.args

            {
                state.ix2060List = action.payload.data

            }
        })
        builder.addCase(loadIx2060List.rejected, (state, action) => {
            state.loadIx2060ListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadIx2060ListError = action.error.message
            } else {
                state.loadIx2060ListError = action.payload
            }
        })

        builder.addCase(loadEwbData.pending, (state) => {
            state.loadEwbDataStatus = 'pending'
            state.loadEwbDataError = undefined
        })
        builder.addCase(loadEwbData.fulfilled, (state, action) => {
            state.loadEwbDataStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.ix2060List.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.ix2060List.push(newItem) }
                else { state.ix2060List[i] = { ...state.ix2060List[i], ...newItem } }
            }
        })
        builder.addCase(loadEwbData.rejected, (state, action) => {
            state.loadEwbDataStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadEwbDataError = action.error.message
            } else {
                state.loadEwbDataError = action.payload
            }
        })

        builder.addCase(saveEwbPerData.pending, (state) => {
            state.saveEwbPerDataStatus = 'pending'
            state.saveEwbPerDataError = undefined
        })
        builder.addCase(saveEwbPerData.fulfilled, (state, action) => {
            state.saveEwbPerDataStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.ix2060List.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.ix2060List.push(newItem) }
                else { state.ix2060List[i] = { ...state.ix2060List[i], ...newItem } }
            }
        })
        builder.addCase(saveEwbPerData.rejected, (state, action) => {
            state.saveEwbPerDataStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveEwbPerDataError = action.error.message
            } else {
                state.saveEwbPerDataError = action.payload
            }
        })

        builder.addCase(updateEwbPerData.pending, (state) => {
            state.updateEwbPerDataStatus = 'pending'
            state.updateEwbPerDataError = undefined
        })
        builder.addCase(updateEwbPerData.fulfilled, (state, action) => {
            state.updateEwbPerDataStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.ix2060List = state.ix2060List.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.ix2060List = state.ix2060List.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(updateEwbPerData.rejected, (state, action) => {
            state.updateEwbPerDataStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.updateEwbPerDataError = action.error.message
            } else {
                state.updateEwbPerDataError = action.payload
            }
        })

    }
})

export const {
    resetloadIx2060ListError,
    resetloadEwbData,
    resetloadEwbDataError,
    resetsaveEwbPerData,
    resetsaveEwbPerDataError,
    resetupdateEwbPerDataError,
    removeFromIx2060ListById,
    removeFromIx2060ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Ix2060Slice.actions
export default Ix2060Slice.reducer
